var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs8Efe4B99(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 42,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21376d",
    d: "M0 0v48h42V0H0zm22.837 37.4c0 4.7-2.362 6.8-5.862 6.8-3.15 0-4.988-1.9-5.95-4.1l3.238-2.2c.612 1.3 1.225 2.3 2.537 2.3s2.1-.6 2.1-2.8V22h3.938l-.001 15.4zm9.363 6.8c-3.675 0-6.038-2-7.175-4.6l3.238-2.1c.875 1.6 1.925 2.7 3.85 2.7 1.663 0 2.713-.9 2.713-2.2 0-1.5-1.05-2.1-2.888-3l-.962-.5c-2.888-1.4-4.725-3.1-4.725-6.8 0-3.4 2.275-6 5.775-6 2.538 0 4.288 1 5.6 3.6l-3.063 2.3c-.7-1.4-1.4-1.9-2.538-1.9-1.137 0-1.925.8-1.925 1.9 0 1.4.7 1.9 2.45 2.7l.963.5c3.325 1.6 5.25 3.3 5.25 7.1 0 4.1-2.801 6.3-6.563 6.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs8Efe4B99);
export default __webpack_public_path__ + "static/media/js.8efe4b99.4efd378875e150c3bad1f0eb3f363842.svg";
export { ForwardRef as ReactComponent };